import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

import { Formatters } from 'Common/Helpers';
import { FALLBACK_IMAGE } from 'Common/Constants';

import ProfileDetailItem from 'PointOfSale/modules/serving/component/ProfileDetailItem';

const ProfileDetail = ({ student = {} }) => {
  const hasImage = Boolean(student.Picture);

  const imageSrc = hasImage
    ? Formatters.prependBase64(student.Picture)
    : FALLBACK_IMAGE;
  return (
    <div className="profile-container">
      <div className="profile-detail-image-wrapper">
        <Image
          fluid
          src={imageSrc}
          className="small-card-image"
          alt={`${student.FullName} Profile Picture`}
        />
      </div>
      <div>
        <ProfileDetailItem
          label="Name"
          value={student.FullName}
          valueClass="bold-title"
        />
        <ProfileDetailItem
          label="Balance"
          value={Formatters.balance(student.Balance)}
          valueClass="bold-title"
        />
        <ProfileDetailItem
          label="Serving Number"
          value={student.ServingNumber}
        />
        <ProfileDetailItem label="Teacher" value={student.Teacher} />
        <ProfileDetailItem label="Grade" value={student.GradeId} />
        <ProfileDetailItem label="Site" value={student.SchoolName} />
      </div>
    </div>
  );
};

ProfileDetail.propTypes = {
  student: PropTypes.object,
};

export default ProfileDetail;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/serving/component/ProfileDetail.js